import { API_KEY_TYPES } from './types';

export const API_KEY_TYPE_VALUES = {
  BULK_LOAD: 'BulkLoad',
  JAVASCRIPT_SDK: 'JavaScriptSDK',
  MOBILE: 'Mobile',
  READ_ONLY: 'ReadOnly',
  SERVER_SIDE: 'ServerSide',
  WEB: 'WebSDK',
};

export const API_KEY_TYPE_VALUE_ORDER: API_KEY_TYPES[] = [
  API_KEY_TYPES.READ_ONLY,
  API_KEY_TYPES.BULK_LOAD,
  API_KEY_TYPES.SERVER_SIDE,
  API_KEY_TYPES.JAVASCRIPT_SDK,
  API_KEY_TYPES.MOBILE,
  API_KEY_TYPES.WEB,
];

export const API_KEY_KEY_TYPE_LABELS = {
  [API_KEY_TYPES.READ_ONLY]: 'Read-only',
  [API_KEY_TYPES.BULK_LOAD]: 'Bulk load',
  [API_KEY_TYPES.STANDARD]: 'Standard',
  [API_KEY_TYPES.SERVER_SIDE]: 'Server-side',
  [API_KEY_TYPES.JAVASCRIPT_SDK]: 'JavaScript',
  [API_KEY_TYPES.MOBILE]: 'Mobile',
  [API_KEY_TYPES.WEB]: 'Web',
};

export const STATUS_TYPES = {
  enabled: { label: 'Enabled', value: true },
  disabled: { label: 'Disabled', value: false },
};

export const JWT_REQUIRED_TYPES = {
  yes: { label: 'Yes', value: true },
  no: { label: 'No', value: false },
};

export const ENDPOINT_PREVIEWS = {
  JavaScriptSDK: `POST /api/users/update
POST /api/events/track
POST /api/commerce/trackPurchase
POST /api/commerce/updateCart`,
  Mobile: `POST /api/users/disableDevice
POST /api/users/registerDeviceToken
POST /api/users/createUserForUserId
POST /api/users/update
POST /api/users/updateEmail
POST /api/users/updateSubscriptions
POST /api/commerce/trackPurchase
POST /api/commerce/updateCart
POST /api/events/trackPushOpen
POST /api/events/trackInAppOpen
POST /api/events/trackInAppClick
POST /api/events/inAppConsume
POST /api/events/track
POST /api/push/target
GET /api/inApp/getMessages`,
  ReadOnly: `GET /api/campaigns
GET /api/channels
GET /api/messageTypes
GET /api/lists
GET /api/users/getFields
GET /api/metadata
GET /api/campaigns/metrics
GET /api/experiments/metrics
GET /api/templates
GET /api/templates/email/get
GET /api/templates/push/get
GET /api/templates/sms/get
GET /api/templates/getByClientTemplateId
GET /api/templates/inapp/get
GET /api/lists/{listId}/size
GET /api/campaigns/recurring/{id}/childCampaigns
GET /api/metadata/{table}
GET /api/metadata/{table}/{key}`,
  ServerSide: `All endpoints accessible`,
};

export const API_KEYS_ERRORS = {
  CREATE: 'api-key-create-error',
  DELETE: 'api-key-delete-error',
  FETCH: 'api-key-fetch-error',
  NAME: 'missing-name-error',
  STATUS: 'missing-status-error',
  KEYTYPE: 'missing-keytype-error',
  JWT_REQUIRED: 'missing-jwt-required-error',
};

export const NAME_COLUMN_VALUE = 'name';
export const STATUS_COLUMN_VALUE = 'enabled';
export const TYPE_COLUMN_VALUE = 'keyType';
export const CUSTOM_EVENT_ALLOW_CREATION_UNTIL = 'customEventManageAllowCreationUntil';
export const LAST_MODIFIED_COLUMN_VALUE = 'updatedAt';
export const LAST_USED_COLUMN_VALUE = 'lastUsedAt';
export const API_KEYS_ACTIONS = 'API_KEYS_ACTIONS'; // This is simply a placeholder name for the column
